import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterItemBindingStatusValue,
  UniversalFilterItemBindingStatusModes,
  UniversalFilterItemBindingStatusOnChange
} from './UniversalFilterItemBindingStatus.types';

import { useUniversalFilterItemBindingStatus } from './hooks/useUniversalFilterItemBindingStatus';

import { ItemsBindingStatusesMultiSelect } from '../../../../../main/groupedItems/helpers/ItemsBindingStatusesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';
import { GroupedItemBindingStatuses } from '../../../../../main/groupedItems/groupedItemsTypes';
import { itemsKeys } from '../../../../../locales/keys';

interface UniversalFilterItemBindingStatusProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterItemBindingStatusValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterItemBindingStatusOnChange;
}

export const bindingStatusI18nTexts = {
  [GroupedItemBindingStatuses.BINDED]: undefined,
  [GroupedItemBindingStatuses.UNBINDED]: itemsKeys.bindingStatuses.postponed,
  [GroupedItemBindingStatuses.MIXED]: itemsKeys.bindingStatuses.mixed
};

function UniversalFilterItemBindingStatus({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterItemBindingStatusProps) {
  const {
    modeOptions,
    filterState,
    handleModeChange,
    handleBindingStatusesChange
  } = useUniversalFilterItemBindingStatus({
    filterStateCacheKey,
    filterValue,
    onChange
  });

  return (
    <UniversalFilterTemplate<UniversalFilterItemBindingStatusModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterItemBindingStatusModes.CONTAINS_ALL_OF
          // UniversalFilterItemBindingStatusModes.DOES_NOT_CONTAIN_ANY_OF
        ],
        filterState.mode
      ) ? (
        <ItemsBindingStatusesMultiSelect
          value={filterState.bindingStatus}
          autoFocus={autoFocus}
          inputWrapperClassName="block"
          onChange={handleBindingStatusesChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterItemBindingStatus;
